define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/action",
	"csi/action/ActionView",
	"csi/action/FormData",
	"csi/breadcrumb/StateActionController",
	"csi/comm",
	"csi/def",
	"csi/reflection",
	"csi/state/rootStore",
	"csi/sessionConstants",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/Search",
	"Apparel/ProductType",
	"Apparel/SamplesForm",
	"./ReviewForm"
], function(array, declare, csi, _, action, ActionView, FormData, StateActionController, comm, def, reflection, {routerStore}, sessionConstants, ActionControllerMixin, xml, Query, Search, ProductType, SamplesForm, ReviewForm) {

	const FIELD_SUPPLIER = "ReviewSupplier";
	const FIELD_SUPPLIER_FACTORY = "ReviewSupplierFactory";

	var _SetupClass = declare(null, {
		runRequest: true,
		request: function(/*Widget*/form, /*Controller*/ac, /*String[]*/urls, /*String[]*/paths) {
			// summary: add urls and paths needed for sizechart
			if (ac._urlRevision) {
				urls.push(ac._urlRevision);
				paths.push("Child:__Parent__/Child:__Parent__/Child:ProductColors");
				paths.push("Child:__Parent__/Child:__Parent__/Child:ProductSourcing/Child:ProductSources/Child:ColorSources");

				paths.push("Child:Sizes");
				paths.push("Child:SizeChartSubSizeRanges");
			}
		},

		init: function(/*csi.form.Widget*/form, /*action.Controller*/ac) {
			// summary: initialize sizes based on Size Chart and quantity to 1 for all
			const cache = form.cacheView;
			const sizeChartRev = cache.getNode(ac._urlRevision);
			const product = ac.getParent();

			// Creating Samples on SizeChart Evaluation, use SizeChartSubSizeRanges BaseSize
			const urlBaseSize = (sizeChartRev.SizeChartSubSizeRanges.length == 1) ? cache.getNode(sizeChartRev.SizeChartSubSizeRanges[0]).BaseSize : null;

			const dimValues = form._setProductDimensions(product.ProductColors, sizeChartRev.Sizes, urlBaseSize, false);

			// do not allow alternate size range
			form.defView.getField(form.SIZE_RANGE).bHidden = true;

			// specify default values if not already specified
			form.addDefaultValue(xml.ATTR_NAME, ac.m_formData.getFieldValue(xml.ATTR_NAME));
			form.addDefaultValue(form.DIMENSIONS, form.DIM_SIZES);
			form.addDefaultValue("ResponsibleUsers", [sessionConstants.userUrl]);

			return dimValues;
		}
	});

	return declare([StateActionController, ActionControllerMixin], {
		// FormData: form data for samples page
		_fdSamples: null,

		// Node: last selected Source(Request)
		_lastSource: null,
		_lastRequest: null,

		// String: URL for SizeChart
		_urlSizeChart: null,

		// String: URL for SizeChartRevision
		_urlRevision: null,

		// csi.form.Widget: handle to sample form
		_viewSampleForm: null,

		/** @property {string} sourceFieldId - the field ID of the source(Supplier or SupplierFactory) */
		sourceFieldId: null,


		constructor: function(/*Object*/params) {
			// summary: override base class parameters while showing SizeChartReview form as if it is being added to Style DataSheets
			this._urlSizeChart = this.m_urlParent;
			this._urlRevision = this.m_urlNode;

			this.m_idAttrParent = "DataSheets";
			this.m_urlParent = this.widget.getViewNode().__Parent__;
			this.m_urlNode = null;
		},

		_preAction: async function() {
			// S11617: Size Chart: When an Evaluation exists Pre-fill the Evaluation Dialog Pop-up with Previous Information
			// fetch the latest review (if exists) and its samples in the request
			// the review will be used in onWizardViewCreate
			let search = new Search().byType("SizeChartReview");

			search.getQuery().RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, this.m_urlParent)
				.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, this._urlSizeChart, "Child:ReviewSizeChart");
			search.getSortQuery().SortByNode(xml.PROP_CREATE_TIME, null, true);
			search.addDependencyPaths(["Child:DataSheetSamples/Index:0"]);
			search.setPageLimits(1, 1);

			const response = await search.execute();
			const review = response.getResultNode();
			if (review) {
				this._reviewURL = review.$URL;
				this.m_cache.add(review);
			}
			return true;
		},

		onWizardViewCreate: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*csi.view.Widget*/view) {

			// S11617: Size Chart: When an Evaluation exists Pre-fill the Evaluation Dialog Pop-up with Previous Information
			var pageIndex = wizard.getIndexOfPage(page);
			var fields = view.defView.m_fields;

			var cache = this.getCache();
			var review = cache.getNode(this._reviewURL);



			if (pageIndex == 0) { // review form
				const product = this.getCache().getNode(this.m_urlParent);
				const isFDDEnabled = ProductType.isFDDProduct(product);

				// pass properties related to FDD to the form
				const reviewForm = page.getView();
				reviewForm.isFDDEnabled = isFDDEnabled;
				this.sourceFieldId = reviewForm.sourceFieldId = isFDDEnabled ? FIELD_SUPPLIER_FACTORY : FIELD_SUPPLIER;

				if (review) {
					this._prefillFields(view, fields, review);

					if (review.DataSheetSamples.length > 1) {
						var sample = cache.getNode(review.DataSheetSamples[0]); // get the first sample in the review

						if (sample && sample.$CT == review.$CT) { // sample was created on the same form as review
							view.addDefaultValue("SizeChartReviewCreateSamples", true); // prefill Create Style Samples checkbox
							this._sample = sample; // its attributes will be used to prefill the fields on the next page of the wizard
						}
					}
				}
			} else if (pageIndex == 1 && this._sample) { // sample form
				var sampleFields = fields.slice();
				// do not prefill Node Name field (because it has the size suffix)
				var nodeNameIndex = sampleFields.indexOf(view.defView.getField("Node Name"));
				sampleFields.splice(nodeNameIndex, 1);

				// do not prefill SampleStatus field
				var sampleStatusIndex = sampleFields.indexOf(view.defView.getField("SampleStatus"));
				sampleFields.splice(sampleStatusIndex, 1);

				this._prefillFields(view, sampleFields, this._sample);
			}
		},

		_prefillFields: function(view, fields, node) {
			var cache = this.getCache();
			_.each(fields, function(field) { // prefill the fields in review form
				var heading = field.heading;
				if (heading && heading.m_id && !heading.m_bHidden) {
					var pathNode = cache.getPathNode(node, heading.m_path, true); // DE26896
					if (pathNode.hasOwnProperty(heading.m_id)) {
						view.addDefaultValue(field.m_id, pathNode[heading.m_id]);
					}
				}
			});
		},

		preProcess: function() {
			// summary: do not allow action if no size chart base size - make sure to get the latest version of the node
			var scr = this.widget.getRevisionNode();

			if (!scr.Sizes.length) {
				this.displayErrorDialog({suffix: "_ErrorSizes"});
			} else {
				this.inherited(arguments);
			}
		},

		disableFinish: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*Number*/index, /*Boolean*/bLast) {
			// summary: return true if on first page
			return index ? false : page.getView().defView.getFieldValue("SizeChartReviewCreateSamples");
		},

		disableNext: function(/*csi.wizard.Widget*/wizard, /*csi.wizard.Content*/page, /*Number*/index, /*Boolean*/bLast) {
			// summary: return true if not on first page
			return !!index;
		},

		getActionView: function(/*ViewRef?*/vr) {
			// summary: popup SizeChartReview wizard
			var rc = reflection.getClass("SizeChartReview");
			var defView = def.getClassViewDef(rc, "__Wizard__");
			defView.tabs[2].m_url = this.m_urlParent;

			return new ActionView(this, defView);
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: filter out samples by supplier and without size
			var q;

			if (index == 2) {
				const {sourceFieldId} = this;
				const isReviewingSupplier = (FIELD_SUPPLIER === sourceFieldId);
				const attributeID = isReviewingSupplier ? "Supplier" : "SupplierFactory";
				q = new Query()
					.RefAttr(attributeID, xml.OP_EQUALS, this._lastSource, reflection.PATH_PARENT);

				if (xml.isValidURL(this._lastRequest)) {
					q.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, this._lastRequest, "Child:SampleSRLineItem");
				}
				var revisionNode = this.getCache().getNode(this._urlRevision);
				var selectedSizes = revisionNode.SelectedSizes;
				if (selectedSizes.length) {
					var qOr = q.Or();
					selectedSizes.forEach(function(size) {
						qOr.RefAttr("ProductSize", xml.OP_EQUALS, size);
					})
				} else {
					q.RefAttr("ProductSize", xml.OP_NOT_EQUALS, csi.EMPTY_URL);
				}


			}

			return q;
		},

		onWizardViewPreCreate: function(/*csi.wizard.Widget*/wizard, /*Content*/page, /*View*/defView, /*Object*/viewParams) {
			// summary: notify when view definition for page is found and ready for creation with ability to add own viewParams
			var pageIndex = wizard.getIndexOfPage(page);
			let parentSource = wizard.defView.m_formData.getSource().getParent();
			viewParams.urlSizeOwner = this._urlRevision;
			if (pageIndex == 1) {
				viewParams.parentNode = parentSource;
			}
		},

		onPrevPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/prevPage) {
			// summary: skip over Samples form if coming from Samples table
			return (wizard.getIndexOfPage(prevPage) == 1) ? wizard.skipToPrevPage(prevPage) : null;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			const nPage = wizard.getIndexOfPage(nextPage);
			let bRefresh, dfd, fd, urlRequest, urlSource, view;

			// nothing extra to do when finishing wizard
			if (bFinish) {
				// DE26863: C8 5.6-Size chart-Evaluate-Pass/Fail: When changing the reviews from Pass to Fail then Evaluate, for some attributes the previous revision values are not updated
				// some fields were prefilled in onWizardViewCreate function, therefore mark all fields as updated
				let fields = this.m_formData.getFields();
				const sampleFields = this._fdSamples && this._fdSamples.getFields();
				if (sampleFields) {
					fields = fields.concat(sampleFields);
				}
				_.each(fields, function(field) {
					field._bUpdated = true;
				});

				return null;
			}

			switch (nPage) {
				// Size Chart Review form
				case 0: {
					fd = this.m_formData;
					break;
				}

				// Create Samples for Style
				case 1: {
					if (this._optionCreateSamples()) {
						const {sourceFieldId, m_formData, _fdSamples} = this;
						urlSource = m_formData.getFieldValue(sourceFieldId);
						urlRequest = m_formData.getFieldValue("ReviewRequest");
						view = nextPage.getView(wizard);
						fd = _fdSamples;

						if (!fd) {
							// setup form to create samples
							fd = this._fdSamples = new FormData(this);
							this._viewSampleForm = view;
							view.setProduct(routerStore.getBreadcrumbNode("Style") || routerStore.getBreadcrumbNode("Shape"), _SetupClass);
						}
						const sourceField = m_formData.getField(sourceFieldId);

						view.setSource(urlSource, sourceField.getNameForValue(urlSource));
						view.setSupplierRequest(currentPage.getView().cacheView.getNode(urlRequest, true));
						const sizeChartReviewName = m_formData.getFieldValue("Node Name");
						view.setSampleName(sizeChartReviewName, fd);
					} else {
						return wizard.skipToNextPage(nextPage);
					}
					break;
				}

				// Select Samples from Style
				case 2: {
					fd = this.m_formData;
					view = nextPage.getView(wizard);
					urlSource = fd.getFieldValue(this.sourceFieldId);
					urlRequest = fd.getFieldValue("ReviewRequest");

					if ((urlSource != this._lastSource) || (urlRequest != this._lastRequest)) {
						// reset selections if supplier changed
						this._lastSource = urlSource;
						this._lastRequest = urlRequest;
						fd.resetSelections();
						bRefresh = true;
					}

					break;
				}
			}

			// set form data for next page in wizard and refresh view if necessary
			if (fd) {
				dfd = wizard.setFormDataToPage(nextPage, fd, bRefresh);
			}

			return dfd;
		},

		toWriter: function() {
			// summary: switch state to review and create SizeChartReview
			var fd = this.m_formData;

			// switch state to review - reset formData so fields are not passed as part of request
			this.m_formData = null;
			this.m_urlNode = this._urlRevision;
			this.m_urlParent = this._urlSizeChart;
			this.toWriterRequest();
			this.m_formData = fd;

			// collect samples from form - either by creating new ones or selecting existing ones
			var samples;

			if (this._optionCreateSamples()) {
				samples = this._viewSampleForm.toWriterSamples(this);
			} else {
				samples = array.map(fd.getSelectedNodes(true), xml.nodeGetURL);
			}

			// create SizeChartReview
			var urlReview = comm.createUrl("SizeChartReview");
			var call = this.m_writer.callMethod("ProductSpec", "SizeChartReviewStart");

			call.addParameter("SourceURL", xml.ATTR_REF, fd.getFieldValue(this.sourceFieldId, true))
				.addParameter("RequestURL", xml.ATTR_REF, fd.getFieldValue("ReviewRequest", true));

			call.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this._urlSizeChart)
				.addParameter(xml.PROP_URL, xml.ATTR_REF, urlReview)
				.addParameter(xml.PROP_AGGREGATE_ADDS, xml.ATTR_REFLIST, samples);

			this.toWriterFields(urlReview);
			this.m_writer.validateNode(urlReview, true);
		},

		_optionCreateSamples: function() {
			// summary: return true if creating samples rather than choosing existing samples
			return this.m_formData.getFieldValue("SizeChartReviewCreateSamples");
		}
	});
});